import React from 'react';
import { Card } from "react-bootstrap";
import face_kira_kovacs from "../../assets/img/success_KiraKovacs.jpg";
import face_csaba_kerepesi from "../../assets/img/face_csaba_kerepesi.png";
import ShowMoreText from "react-show-more-text";
import proj_age_prediction from "../../assets/img/proj_age_prediction.png";

const Cs_Kerepesi_and_K_Kovacs_age_prediction = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_age_prediction} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_csaba_kerepesi}
              alt="Synthetic Data Generation for Data Balancing in Age Prediction"
            />{" "}
            <p className="text7">Csaba Kerepesi</p>
            <br />
            <p className="text8">
                Group leader{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_kira_kovacs}
              alt="Synthetic Data Generation for Data Balancing in Age Prediction"
            />{" "}
            <p className="text7">Kíra Diána Kovács</p>
            <br />
            <p className="text8">
              PhD Student{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">HUN-REN SZTAKI, BioAgeAI Research Group</p>
            </div>
            <div>
            <p className="text8">BME</p>
            </div>
            <div>
            Age prediction models are widely used in biological aging research to estimate an individual's 
            biological age from molecular, clinical, or other high-dimensional biological data. However, 
            training datasets often contain uneven age distributions, with some age groups being 
            overrepresented while others are poorly represented. This imbalance can introduce systematic 
            prediction bias, particularly causing the model to overestimate the age of younger individuals 
            and underestimate the age of older individuals. 
            <br />
            <br />
            To address this problem, this project will investigate whether synthetic data generation can be 
            used to balance the age distribution of training datasets and thereby reduce age-dependent 
            prediction bias. 
            <br />
            <br />
            The main hypothesis is that models trained on a more uniform age distribution will exhibit less 
            systematic over- or underprediction across the age range than models trained on an imbalanced 
            dataset. If this hypothesis is supported, synthetic data generation could provide a way to 
            improve age prediction models and potentially reduce the need for post-hoc correction methods 
            such as age acceleration or regression-based bias correction.
            <br />
            <br />
            The main research questions are:
            <ul>
                <li>
                  To what extent does an imbalanced age distribution contribute to systematic bias in 
                  age prediction? 
                </li>
                <li>
                  Does balancing the age distribution reduce the tendency of age prediction models to 
                  overestimate younger individuals and underestimate older individuals? 
                </li>
                <li>
                  Can synthetic data generation improve prediction accuracy and calibration compared 
                  with conventional training on an imbalanced dataset? 
                </li>
                <li>
                  Does the effectiveness of synthetic data generation depend on the prediction model 
                  or the underlying biological data type? 
                </li>
                <li>
                  Can a model trained on a balanced age distribution provide sufficiently unbiased 
                  predictions to reduce the need for age-acceleration correction in downstream 
                  biological aging analyses? 
                </li>
            </ul>
            
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};
export default Cs_Kerepesi_and_K_Kovacs_age_prediction;